import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useDispatch } from "react-redux";

import ClaimsByManagementType from './ClaimsByManagementType';
import ClaimsByStatus from "./ClaimsByStatus";
import Sinistres from "../Sinistres/Sinistres";

import { filterClaimm } from "../../store/action/claim";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    dialogTitle: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px',
        letterSpacing: '0.5px',
        textAlign: 'left',
        marginBottom: theme.spacing(2),
        color: 'rgba(73, 75, 105, 1)',
        backgroundColor: 'rgba(244, 244, 244, 1)',
    },
    separator: {
        width: '1px',
        backgroundColor: 'rgba(229, 234, 238, 1)',
        height: '100%',
        margin: '0 16px',
    },
}));

const ChartDialog = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [indexRoute, setIndexRoute] = useState('Sinistre');
    const [idClaim, setIdClaim] = useState(null);

    const [claims, setClaims] = useState([]);
    const [loading, setLoading] = useState(false);

    const {
        open,
        onClose,
        managementTypeClaimsByManagementType,
        claimStatusClaimsByStatus,
    } = props;

    // 🔥 CALL FILTER CLAIM WHEN OPENING
    useEffect(() => {
        if (!open) return;

        const filters = {};

        if (managementTypeClaimsByManagementType) {
            filters.managementType = managementTypeClaimsByManagementType;
        }

        if (claimStatusClaimsByStatus) {
            filters.status = claimStatusClaimsByStatus;
        }

        setLoading(true);

        dispatch(filterClaimm(filters, 1, 20))
            .then((data) => {
                setClaims(data);
            })
            .catch(() => {
                setClaims([]);
            })
            .finally(() => {
                setLoading(false);
            });

    }, [
        open,
        dispatch,
        managementTypeClaimsByManagementType,
        claimStatusClaimsByStatus,
    ]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xxl" fullWidth>
            <DialogTitle className={classes.dialogTitle}>
                Dashboard <span style={{ fontWeight: 600 }}>/ Sinistres</span>

                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={onClose}
                    aria-label="close"
                    style={{ position: 'absolute', right: 15, top: 5 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent
                style={{
                    display: 'flex',
                    height: '600px',
                    alignItems: 'flex-start',
                }}
            >
                {/* LEFT SIDE CHART */}
                <Box
                    style={{
                        width: '32%',
                        height: '100%',
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                    }}
                >
                    {managementTypeClaimsByManagementType === undefined ? (
                        <ClaimsByStatus
                            disableClick
                            claimStatusClaimsByStatus={claimStatusClaimsByStatus}
                        />
                    ) : claimStatusClaimsByStatus === undefined ? (
                        <ClaimsByManagementType
                            disableClick
                            managementTypeClaimsByManagementType={
                                managementTypeClaimsByManagementType
                            }
                        />
                    ) : null}
                </Box>

                <Box className={classes.separator} />

                {/* RIGHT SIDE LIST */}
                <Box
                    sx={{
                        width: '68%',
                        height: '100%',
                        overflow: 'auto',
                        boxSizing: 'border-box',
                        paddingTop: '0px',
                        marginTop: '0px',
                        "&::-webkit-scrollbar": {
                            width: "5px",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "rgba(217, 217, 217, 0.5)",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: "rgba(187, 200, 8, 0.58)",
                            borderRadius: "5px",
                        },
                    }}
                >
                    <Box>
                        <Sinistres
                            claims={claims}
                            loading={loading}
                            claimStatusClaimsByStatus={claimStatusClaimsByStatus}
                            managementTypeClaimsByManagementType={
                                managementTypeClaimsByManagementType
                            }
                            indexRoute={indexRoute}
                            setIndexRoute={setIndexRoute}
                            setIdClaim={setIdClaim}
                        />
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ChartDialog;
